/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {sessionget, sessionset} from './utils/SessionStorage';

//https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
function hashCode(str) {
  let hash = 0, i, chr;
  if (str.length === 0) {
    return hash;
  }
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

function getHashedKey(...args) {
  return hashCode(args.toString());
}

export function getData(datakey, ...identifiers) {
  return sessionget(getHashedKey(datakey, identifiers));
}

export function setData(data, datakey, ...args) {
  if (data && (datakey in data)) {
    let hashedkey = getHashedKey(datakey, args);
    sessionset(hashedkey, data[datakey]);
  }
}

export function setShellInitDataForLogin(shellInitData, inputIdVariables) {
  const {locale, sessionUrl, userId} = inputIdVariables;
  const {orgId} = (shellInitData.userOrgSettings || {});
  const {currentAnalyticsPC} = (shellInitData.imsSSOhandler || {});
  const session = {
    imsSessionData: {
      current_active_org: {
        org_auth_src: 'AdobeOrg',
        org_id: orgId ? orgId.split('@')[0] : undefined
      },
      current_active_pc: {
        dma_analytics: {
          ident: currentAnalyticsPC,
          serviceCode: 'dma_analytics'
        }
      }
    }
  };

  setData(shellInitData, 'userOrgs');
  setData(shellInitData, 'userBehance', userId);
  setData(shellInitData, 'userOrgSettings', orgId, locale);
  setData(shellInitData, 'timeline', orgId, locale);
  setData(session, 'imsSessionData', sessionUrl);
}

export function setShellInitDataForReload(shellInitData, inputIdVariables) {
  const {locale, sessionUrl, userId} = inputIdVariables;
  const {orgId} = (shellInitData.userOrgSettings || {});
  setData(shellInitData, 'userOrgs');
  setData(shellInitData, 'imsSessionData', sessionUrl);
  setData(shellInitData, 'userBehance', userId);
  setData(shellInitData, 'userOrgSettings', orgId, locale);
  setData(shellInitData, 'timeline', orgId, locale);
}
